<script>
export default {
    replace:false,
    data () {
        return {
            email:false,
            nickname:false
        }
    },
    methods:{
        submit(e){
            let fields = document.querySelectorAll('input[type="text"],input[type="email"]');
            fields.forEach(f => {
                if(f.value.includes('http:') || f.value.includes('https:')){
                    e.preventDefault();
                    alert('please enter a valid value');
                    return false;
                }
            })
        }
    }
}
</script>
